import { seoArticles } from './seoArticlesData';

export default function ArticleCardsSection() {
  return (
    <section className="w-full py-14 md:py-20 px-6 md:px-10 bg-background-50" id="artigos">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-800 rounded-full text-xs font-semibold tracking-wide mb-4">
            ARTIGOS SEO
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
            Guias e Tutoriais CSSBuy Spreadsheet
          </h2>
          <p className="mt-3 text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            Conteúdo original e atualizado para ajudar você a dominar o CSSBuy
            Spreadsheet e importar da China como um profissional.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.slice(0, 3).map((article, idx) => (
            <a
              key={article.slug}
              href={article.slug}
              className="group relative rounded-2xl overflow-hidden block"
            >
              <div className="w-full h-[420px] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2 py-0.5 bg-accent-500/80 text-background-50 rounded text-[10px] font-semibold mb-2">
                  {idx === 0 ? 'MAIS LIDO' : idx === 1 ? 'RECOMENDADO' : 'POPULAR'}
                </span>
                <h3 className="text-white text-lg md:text-xl font-heading font-semibold leading-snug mb-2">
                  {article.title}
                </h3>
                <p className="text-white/80 text-sm leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {article.description}
                </p>
                <span className="inline-flex items-center gap-1 text-white/90 text-xs mt-2 font-medium">
                  Ler artigo
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-5 md:gap-6 mt-5 md:mt-6">
          {seoArticles.slice(3, 7).map((article) => (
            <a
              key={article.slug}
              href={article.slug}
              className="group relative rounded-2xl overflow-hidden block"
            >
              <div className="w-full h-[340px] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <h3 className="text-white text-base md:text-lg font-heading font-semibold leading-snug mb-1">
                  {article.title}
                </h3>
                <span className="inline-flex items-center gap-1 text-white/80 text-xs mt-1 font-medium">
                  Ler artigo
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 md:gap-6 mt-5 md:mt-6">
          {seoArticles.slice(7, 13).map((article, idx) => (
            <a
              key={article.slug}
              href={article.slug}
              className="group relative rounded-2xl overflow-hidden block"
            >
              <div className={`w-full ${idx === 0 ? 'h-[380px]' : 'h-[280px]'} overflow-hidden`}>
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <h3 className="text-white text-base md:text-lg font-heading font-semibold leading-snug mb-1">
                  {article.title}
                </h3>
                <span className="inline-flex items-center gap-1 text-white/80 text-xs mt-1 font-medium">
                  Ler artigo
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>

        {seoArticles.length > 13 && (
          <div className="mt-5 md:mt-6">
            <a
              href={seoArticles[13].slug}
              className="group relative rounded-2xl overflow-hidden block"
            >
              <div className="w-full h-[340px] overflow-hidden">
                <img
                  src={seoArticles[13].imageUrl}
                  alt={seoArticles[13].title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2 py-0.5 bg-primary-500/80 text-background-50 rounded text-[10px] font-semibold mb-2">
                  DOWNLOAD GRÁTIS
                </span>
                <h3 className="text-white text-xl md:text-2xl font-heading font-semibold leading-snug mb-2">
                  {seoArticles[13].title}
                </h3>
                <p className="text-white/80 text-sm leading-relaxed max-w-lg">
                  {seoArticles[13].description}
                </p>
                <span className="inline-flex items-center gap-1 text-white/90 text-xs mt-2 font-medium">
                  Baixar agora
                  <i className="ri-download-line"></i>
                </span>
              </div>
            </a>
          </div>
        )}
      </div>
    </section>
  );
}